import { Info as InfoType, FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { Message } from '@flos/react-ui';
// import { InlineMarkdown } from 'react-inline-markdown';

// This one is identical to Attention
// However, there are more info in the Info in form.io
// We need to extract that and somehow show it

const Info = ({ caption, value, contentType, theme }: InfoType) => {
    return (
        <div className="u-spacing-stack-l">
            <Message theme={theme}>
                <div>
                    {caption && (
                        <>
                            <strong dangerouslySetInnerHTML={{ __html: caption }} />
                            <br />
                            <br />
                        </>
                    )}
                    {infoContent(value, contentType)}
                </div>
            </Message>
        </div>
    );
};

const infoContent = (value: string | string[] | undefined, contentType?: string) => {
    if (value instanceof Array) {
        switch (contentType) {
            case 'plain':
                return (
                    <>
                        {value.map((content, i) => (
                            <div key={i}>{content}</div>
                        ))}
                    </>
                );
            case 'list':
                return (
                    <ul>
                        {value.map((content, i) => (
                            <li key={i}>{content}</li>
                        ))}
                    </ul>
                );

            case 'numberedList':
                return (
                    <ol>
                        {value.map((content, i) => (
                            <li key={i}>{content}</li>
                        ))}
                    </ol>
                );
        }
    }
    return (
        <p>
            <strong>{value}</strong>
        </p>
    );
};
Info.isValid = (formConfig: FormConfig, formValues: FormValues, elementId: string): boolean => {
    return true;
};

export default Info;
